import React, { Suspense, useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import SEO from "../Components/SEO";

function Layout({ children, title }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);


  const MenuToggle = () => {
    setShow(!show);
  };

  // Log out the user by removing cookies and local storage data
  const LogOut = () => {
    sessionStorage.removeItem("token", { path: "/" });
    sessionStorage.removeItem("agentDetails", { path: "/" });
    sessionStorage.removeItem("userDetails", { path: "/" });
    sessionStorage.removeItem("agentData", { path: "/" });
    sessionStorage.removeItem("userdata", { path: "/" });
    localStorage.removeItem("agentData");
    localStorage.removeItem("userdata");
    navigate("/");
  };

  // Get SEO data based on current route
  const getSEOData = () => {
    const baseUrl = "https://playrep.me";
    const path = location.pathname;
    
    const seoConfig = {
      "/": {
        title: "Playrep - Premium Gaming Platform | Playrep VIP, Playrep Pro, Playrep.me",
        description: "Welcome to Playrep - The ultimate gaming platform. Experience Playrep VIP, Playrep Pro, and Playrep.me with premium features, revenue management, and seamless gameplay. Join the best gaming experience today!",
        keywords: "playrep vip, playrep pro, playrep me, playrep, gaming platform, playrep login, online gaming, playrep vip login, playrep pro features, playrep.me services",
        url: baseUrl
      },
      default: {
        title: title || "Playrep - Premium Gaming Platform | Playrep VIP, Playrep Pro, Playrep.me",
        description: "Experience the ultimate gaming platform with Playrep VIP, Playrep Pro, and Playrep.me. Premium gaming services with advanced features, revenue management, and seamless gameplay.",
        keywords: "playrep vip, playrep pro, playrep me, playrep, gaming platform, online gaming, revenue management, gaming dashboard",
        url: `${baseUrl}${path}`
      }
    };
    
    return seoConfig[path] || seoConfig.default;
  };

  const seoData = getSEOData();

  useEffect(() => {
    const timer = setTimeout(() => {
      LogOut();
    }, 900000);
    return () => clearTimeout(timer);
  }, []);
  
  return (
    <div>
      <SEO 
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
        url={seoData.url}
      />
      <div className={`dashboard_wrapper ${show ? "active" : ""} main`}>
        <div className="gridContainer dashboard_play">
          <Header />
          <Suspense fallback={""}>
            <div className={"container"}>{children}</div>
          </Suspense>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Layout;
